const isAggregatedMeasure = (transformation) => transformation?.steps?.findIndex((s) => s.$type === "AggregatedModelTableDatasetStep") > -1;
const isDataView = (transformation) => transformation?.$type === "ViewTransformation";

module.exports = {
    isAggregatedMeasure,
    isDataView,
};
